var webSocketConnect = null

export function setWebSocketConnect(ws){
    webSocketConnect = ws
}

export function getWebSocketConnect(){
    return webSocketConnect
}